import FieldValidationCodes from '@/lib/fieldValidationCodes'
import BranchDto from '@/models/Branches/BranchDto';
import ContactProfileSearchRequest from '@/models/Contacts/ContactProfileSearchRequest';
import LocationDto from '@/models/Locations/LocationDto';
import numberUtils from './numberUtils';

export default class Validator {

    static forField(field: string, otherField: any) {
        switch (field) {
            case FieldValidationCodes.Time:
                return [] = [
                    (v: string) => !!v || 'Time is required',
                    function(v: string) {
                        //console.log(v);
                    },
                    (v: string) => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'Time is invalid.'
                ]
            case FieldValidationCodes.BuildingNameNumber:
                return this.stringFieldRules("Building Name/Number", 0, 100, false);
            case FieldValidationCodes.BuildingNameNumberRequired:
                return this.stringFieldRules("Building Name/Number", 0, 100, true);
            case FieldValidationCodes.StreetRoadBlock:
                return this.stringFieldRules("Street", 0, 100, false);
            case FieldValidationCodes.StreetRoadBlockRequired:
                return this.stringFieldRules("Street", 0, 100, true);
            case FieldValidationCodes.Biography:
                return this.stringFieldRules("Biography", 0, 500, true);
            case FieldValidationCodes.BrandName:
                return this.stringFieldRules("Brand Name", 0, 50, true);
            case FieldValidationCodes.CityTown:
                return this.stringFieldRules("City/Town", 0, 100, true);
            case FieldValidationCodes.Locality:
                return this.stringFieldRules("Locality", 0, 100, false);
            case FieldValidationCodes.CountryCode:
                return this.stringFieldRules("Country", 2, 2, true);
            case FieldValidationCodes.Code:
                return this.stringFieldRules("Code", 3, 50, true);
            case FieldValidationCodes.Description:
                return this.stringFieldRules("Description", 0, 500, false)
            case FieldValidationCodes.EmailAddress:
                return this.stringFieldRules("E-mail", 0, 75, false);
            case FieldValidationCodes.EmailAddressMandatory:
                // return this.stringFieldRules("E-mail", 0, 75, true);
                // // var stringRules = this.stringFieldRules("E-mail", 0, 75, false);
                // // return stringRules.concat((v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid');
                return [] = [
                    (v: string) => !!v || 'E-mail is required',
                    (v: string) => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
                ]

                
            case FieldValidationCodes.IntegrationSetting:
                // No length limit — values are defined by the integrated
                // system (API keys, URLs, references); the DB column is text.
                return [];
            case FieldValidationCodes.DateOfBirth:
               
                return [] = [
                    (v: string) => !!v || 'Date Of Birth is required',
                    (v: string) => /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/.test(v) || 'Must be DD/MM/YYYY.'
                ]
            
            case FieldValidationCodes.HealthAndSafetyAssessmentDate:
            
                return [] = [
                    (v: string) => !!v || 'Date is required',
                    (v: string) => /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/.test(v) || 'Must be DD/MM/YYYY.'
                ]
            case FieldValidationCodes.FirstName:
                return this.stringFieldRules("First Name", 0, 50, true);
            case FieldValidationCodes.LastName:
                return this.stringFieldRules("Last Name", 0, 50, true);
            case FieldValidationCodes.EmergencyContactName:
                return this.stringFieldRules("Name", 0, 100, true);
            case FieldValidationCodes.Name:
                return this.stringFieldRules("Name", 3, 50, true);
            case FieldValidationCodes.QuestionTitle:
                return this.stringFieldRules("Title", 3, 255, true);
            case FieldValidationCodes.PhoneNumber:
                return this.stringFieldRules("Phone Number", 0, 50, false);
            case FieldValidationCodes.PhoneNumberMandatory:
            case FieldValidationCodes.EmergencyContactPhoneNumber:
                return this.stringFieldRules("Phone Number", 0, 50, true);
            case FieldValidationCodes.PostZipCode:
                return this.stringFieldRules("Post Code", 0, 50, false);
            case FieldValidationCodes.PostZipCodeRequired:
                return this.stringFieldRules("Post Code", 0, 50, true);
            case FieldValidationCodes.RegisteredName:
                return this.stringFieldRules("Registered Name", 0, 100, true);
            case FieldValidationCodes.RegistrationNumber:
                return this.stringFieldRules("Registration Number", 0, 50, false);
            case FieldValidationCodes.StateProvinceRegion:
                return this.stringFieldRules("County", 0, 100, false);
            case FieldValidationCodes.TaxNumber:
                return this.stringFieldRules("Tax Number", 0, 50, false);
            case FieldValidationCodes.JobTitle:
                return this.stringFieldRules("Job Title", 0, 50, false);
            case FieldValidationCodes.Website:
                return this.stringFieldRules("Website", 0, 200, false);
            case FieldValidationCodes.UrlWithPath:
                return this.stringFieldRules("Website", 0, 500, false);
            case FieldValidationCodes.Instructions:
                return this.stringFieldRules("Instructions", 0, 200, false);
            case FieldValidationCodes.InterviewInstructions:
                return this.stringFieldRules("Instructions", 0, 500, false);
            case FieldValidationCodes.InterviewFeedback:
                return this.stringFieldRules("Feedback", 0, 500, false);
            case FieldValidationCodes.PayrollNumber:
                return this.stringFieldRules("Payroll Number", 0, 50, false);
            case FieldValidationCodes.NationalInsuranceNumber:
                return this.stringFieldRules("National Insurance Number", 9, 50, false);
            case FieldValidationCodes.NationalInsuranceNumberRequired:
                return this.stringFieldRules("National Insurance Number", 9, 50, true);
            case FieldValidationCodes.BankAccountName:
                return this.stringFieldRules("Bank Account Name", 0, 50, false);
            case FieldValidationCodes.BankAccountSortCode:
                return this.stringFieldRules("Sort Code", 6, 6, false);
            case FieldValidationCodes.BankAccountNumber:
                return this.stringFieldRules("Bank Account Number", 8, 8, false);
            case FieldValidationCodes.ConvictionDetails:
                return this.stringFieldRules("Conviction Details", 0, 500, true);
            case FieldValidationCodes.FaqTitle:
                return this.stringFieldRules("Title", 3, 100, true);
            case FieldValidationCodes.LegacyId:
                return this.stringFieldRules("Legacy Id", 1, 50, false);
            case FieldValidationCodes.OfflineMessage:
                return this.stringFieldRules("Offline Message", 5, 200, true);
            case FieldValidationCodes.Latitude:
                return this.numberFieldRules("Latitude", -90, 90, true);
            case FieldValidationCodes.Longitude:
                return this.numberFieldRules("Longitude", -180, 180, true);
            case FieldValidationCodes.AddressTypes:
                return this.multiSelectRules("Address Types", 1, 50, false);
            case FieldValidationCodes.BookingRoleUniform:
                return this.singleSelectEmptyIdRules("Uniform");    
            case FieldValidationCodes.BookingRolePosition:
                return this.singleSelectEmptyIdRules("Position");    
            case FieldValidationCodes.BookingRoleSkills:
                return this.multiSelectRules("Skills", 1, 5, true);    
            case FieldValidationCodes.BookingRoleDesk:
                return this.singleSelectEmptyIdRules("Desk");    
            case FieldValidationCodes.BookingBranch:
                return this.singleSelectRules("Branch");
            case FieldValidationCodes.QuestionType:
                return this.singleSelectRules("Question Type");
            case FieldValidationCodes.LocationType:
                return this.singleSelectEmptyIdRules("Location Type");
            case FieldValidationCodes.BookingLocation:
                return this.singleSelectEmptyIdRules("Location");
            case FieldValidationCodes.BookingContact:
                return this.singleSelectEmptyIdRules("Contact");
            case FieldValidationCodes.BookingOwner:
                return this.singleSelectEmptyIdRules("Owner");
            case FieldValidationCodes.BookingDate:
                return this.singleSelectRules("Date");
            case FieldValidationCodes.AvailabilityRestrictionDate:
                return this.singleSelectRules("Date");
            case FieldValidationCodes.BookingWorker:
                return this.singleSelectRules("Worker");
            case FieldValidationCodes.BookingInstructions:
                return this.stringFieldRules("Instructions", 0, 500, false);
            case FieldValidationCodes.BookingPurchaseOrderNumber:
                return this.stringFieldRules("PO Number", 0, 50, false);
            case FieldValidationCodes.ShiftDate:
                return this.singleSelectRules("Date");
            case FieldValidationCodes.BookingDates:
                return this.multiSelectRules("Dates", 1, 7, true);
            case FieldValidationCodes.WorkTypes:
                return this.multiSelectRules("Work Types", 1, 2, true);
            case FieldValidationCodes.Position:
                return this.singleSelectRules("Position");
            case FieldValidationCodes.PayRate:
                return this.currencyFieldRules("Pay Rate");
            case FieldValidationCodes.Time15MinuteIntervals:
                return this.time15MinuteIntervals();
            case FieldValidationCodes.Password:
                return [] = [
                    (v: string) => !!v || 'Password is required',
                    (v: string) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,32}$/.test(v) || 'Password must contain at least one upper and lowercase letter, special character, number and be between 8-32 characters.',
                ];
            case FieldValidationCodes.AppMinimumVersion:
                return [] = [
                    (v: string) => !!v || 'Minimum version is required',
                    (v: string) => /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/.test(v) || 'Minimum version must match semantic versioning schema.',
                ]
            case FieldValidationCodes.DeclinedReason:
                return this.singleSelectRules("Declined Reason");
            case FieldValidationCodes.CancelledReason:
                return this.singleSelectRules("Cancelled Reason");
            case FieldValidationCodes.BookingRoleWorkerShiftRejectedReason:
                return this.singleSelectRules("Rejected Reason");
            case FieldValidationCodes.Distance:
                return this.decimalFieldRules("Distance", 0, 10000, 1, true);
            case FieldValidationCodes.EmailTemplateType:
                return this.singleSelectRules("Type");
            case FieldValidationCodes.EmailTemplateId:
                return this.singleSelectRules("Template");
            case FieldValidationCodes.IntegrationSystemId:
                return this.singleSelectRules("Integration");
            case FieldValidationCodes.JourneyTemplate:
                return this.singleSelectRules("Journey Template");
            case FieldValidationCodes.JobBranch:
                return this.singleSelectEmptyIdRules("Branch");
            case FieldValidationCodes.JobLocation:
                return this.singleSelectEmptyIdRules("Location");
            case FieldValidationCodes.JobContact:
                return this.singleSelectEmptyIdRules("Contact");
            case FieldValidationCodes.JobOwner:
                return this.singleSelectEmptyIdRules("Owner");
            case FieldValidationCodes.JobDesk:
                return this.singleSelectEmptyIdRules("Desk");
            case FieldValidationCodes.JobSalaryMin:
                return this.currencyFieldRules("Minimum Salary");
            case FieldValidationCodes.JobSalaryMax:
                return this.currencyFieldRules("Maximum Salary");
            case FieldValidationCodes.JobPrimaryPosition:
                return this.singleSelectEmptyIdRules("Position");
            case FieldValidationCodes.JobTitleRequired:
                return this.stringFieldRules("Title", 0, 50, true);
            case FieldValidationCodes.JobDesiredStartDate:
                return this.stringDateFieldRules("Date");
            case FieldValidationCodes.JobClosedReason:
                return this.singleSelectRules("Closed Reason");
            case FieldValidationCodes.InterviewInstructions:
                return this.stringFieldRules("Instructions", 0, 500, false);
            case FieldValidationCodes.InterviewFeedback:
                return this.stringFieldRules("Feedback", 0, 500, false);
            case FieldValidationCodes.InterviewContact:
                return this.singleSelectEmptyIdRules("Contact");
            case FieldValidationCodes.InterviewOtherLocation:
                return this.singleSelectRules("Other Location");
            case FieldValidationCodes.InterviewOfficeAddress:
                return this.singleSelectRules("Office Address");
            case FieldValidationCodes.InterviewType:
                return this.singleSelectRules("Type");
            case FieldValidationCodes.InterviewInPersonAddressType:
                return this.singleSelectRules("Address Type");
            case FieldValidationCodes.InterviewDate:
                return [] = [
                    (v: string) => !!v || 'Date is required',
                    
                    (v: string) => /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(v) || 'Date is required.'
                ]
            case FieldValidationCodes.JobOfferStartDate:
            
                return [] = [
                    (v: string) => !!v || 'Date is required',
                    
                    (v: string) => /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(v) || 'Date is required.'
                ]
            case FieldValidationCodes.JobOfferSalary:
                return this.currencyFieldRules("Salary");
            case FieldValidationCodes.PasswordConfirmation:
                return this.fieldConfirm("Password Confirmation", otherField);
            case FieldValidationCodes.ConversationTopicBranch:
                return this.singleSelectEmptyIdRules("Branch");
            case FieldValidationCodes.ConversationTopicDesk:
                return this.singleSelectEmptyIdRules("Desk");
            case FieldValidationCodes.ConversationTopicBusinessHours:
                return this.singleSelectEmptyIdRules("Business Hours");
            case FieldValidationCodes.ConversationTopicBusinessHoursGroup:
                return this.singleSelectEmptyIdRules("Business Hours Group");
            case FieldValidationCodes.ConversationTopicOutOfHoursGroup:
                return this.singleSelectEmptyIdRules("Out Of Hours Group");
            case FieldValidationCodes.ConversationTopic:
                return this.singleSelectEmptyIdRules("Conversation Topic");
            case FieldValidationCodes.ConversationSubject:
                return this.stringFieldRules("Subject", 3, 100, false);
            case FieldValidationCodes.ConversationMessage:
                return this.stringFieldRules("Message", 3, 500, false);
            case FieldValidationCodes.DefaultBranch:
                return this.singleSelectRules("Default Branch");
            case FieldValidationCodes.DefaultDesk:
                return this.singleSelectRules("Default Desk"); 
            case FieldValidationCodes.DeskExternalAccountingAccount:
                return this.stringFieldRules("Account", 0, 100, false);
            case FieldValidationCodes.DeskExternalAccountingCategory:
                return this.stringFieldRules("Category", 0, 100, false);
            case FieldValidationCodes.Status:
                return this.singleSelectRules("Status");
            case FieldValidationCodes.SpecOutWorker:
                return this.singleSelectRules("Worker");
            case FieldValidationCodes.SpecOutOwner:
                return this.singleSelectRules("Owner");
            case FieldValidationCodes.SpecOutBranch:
                return this.singleSelectRules("Branch");
            case FieldValidationCodes.SpecOutDesk:
                return this.singleSelectRules("Desk");
            case FieldValidationCodes.SpecOutEmailTemplate:
                return this.singleSelectRules("Email Template");
            case FieldValidationCodes.OpportunityName:
                return this.stringFieldRules("Name", 1, 150, true);
            case FieldValidationCodes.OpportunitySource:
                return this.singleSelectRules("Source");
            case FieldValidationCodes.OpportunityOwner:
                return this.singleSelectRules("Owner");
            case FieldValidationCodes.OpportunityWorkType:
                return [(v: any) => (otherField && Array.isArray(otherField.workTypes) && otherField.workTypes.length > 0) || 'Select Permanent, Temp, or both'];
        }
        return;
    }

    static stringFieldRules(fieldName: string, min: number, max: number, mandatory: boolean) {
        //console.log("validation of " + fieldName);
        if (mandatory) {
            return [] = [
                (v: string) => !!v || `${fieldName} is required`,
                (v: string) => v.length >= min || `${fieldName} must be ${min} or more characters`,
                (v: string) => v.length <= max || `${fieldName} must not be more than ${max} characters`,
            ];
        }
        return [] = [
            (v: string) => v.length >= min || `${fieldName} must be ${min} or more characters`,
            (v: string) => v.length <= max || `${fieldName} must not be more than ${max} characters`,
        ];

    }

    static fieldConfirm(fieldName: string, otherField: any) {
        //console.log("validation of " + fieldName);
        return [] = [
            (v: string) => v === otherField || `${fieldName} must match`,
        ];
    }

    static stringDateFieldRules(fieldName: string) {
        //console.log("validation of " + fieldName);
        return [] = [
            (v: string) => !!v || `${fieldName} is required`,
        ];
    }

    static time15MinuteIntervals() {
        //console.log("validation of time");
        return [] = [
            (v: string) => !!v || `Time is required`,
           function(v: string) {
                console.log(v);
                
                    const allowedMinutes = [ "00", "15", "30" , "45"]
                    return allowedMinutes.includes(v.split(":")[1]) || '15m intervals only'
                },
        ]
    }

    static numberFieldRules(fieldName: string, min: number, max: number, mandatory: boolean) {
        //console.log("validation of " + fieldName);
        if (mandatory) {
            return [] = [
                (v: number) => !!v || `${fieldName} is required`,
                (v: number) => v >= min || `${fieldName} must be ${min} or more`,
                (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
            ];
        }
        return [] = [
            (v: number) => v >= min || `${fieldName} must be ${min} or more`,
            (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
        ];
    }

    static decimalFieldRules(fieldName: string, min: number, max: number, maxPrecision: number, mandatory: boolean) {
        //console.log("validation of " + fieldName);
        if (mandatory) {
            return [] = [
                function(v: string) {
                    //console.log(v);
                    return true;
                },
                (v: number) => (v !== null || v !== undefined) || `${fieldName} is required`,
                (v: number) => v >= min || `${fieldName} must be ${min} or more`,
                (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
                (v: number) => numberUtils.countDecimals(v) <= maxPrecision || `${fieldName} must not be more than ${maxPrecision} decimal place`,
            ];
        }
        return [] = [
            (v: number) => v >= min || `${fieldName} must be ${min} or more`,
            (v: number) => v <= max || `${fieldName} must not be more than ${max}`,
        ];
    }

    static currencyFieldRules(fieldName: string) {
        return [] = [
            function(v: string) {
                //console.log(v + typeof(v));
                v = v.toString().replace(/,/g, "");
                return Number(v) > 0 ? true : `${fieldName} must be greater than zero`;
               },

       ];
    }

    static multiSelectRules(fieldName: string, min: number, max: number, mandatory: boolean) {
        //console.log("validation of " + fieldName);
        if (mandatory) {
            //console.log("validation of mandatory " + fieldName);
            return [] = [
                // function(v: any) {
                //     debugger
                //     console.log("hello" + v);
                //     return false;
                // },
                (v: any) => !!v || `${fieldName} is required`,
                (v: any) => v.length >= min || `${fieldName} must be ${min} or more`,
                (v: string) => v.length <= max || `${fieldName} must not be more than ${max}`,
            ];
        }
        return [] = [
            (v: any) => v.length >= min || `${fieldName} must be ${min} or more`,
                (v: string) => v.length > max || `${fieldName} must not be more than ${max}`,
        ];

    }

    static singleSelectRules(fieldName: string) {
        //console.log("validation of " + fieldName);
        return [] = [
            (v: any) => !!v || `${fieldName} is required`,
        ];
       
    }

    static singleSelectEmptyIdRules(fieldName: string) {
        //console.log("validation of " + fieldName);
        return [] = [
             function(v: any) {
                    if (v .id=== '00000000-0000-0000-0000-000000000000' || v.id === undefined) {
                        return `${fieldName} is required`;
                    }
                    return true;
                },
            //  (v: any) => v.id ==='00000000-0000-0000-0000-000000000000' || `${fieldName} is required`,
        ];
       
    }

}